import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import {
  tannerBlack,
  tannerBlue,
  tannerGray,
  tannerPurple,
  tannerSemantic,
} from '../colors';

type MuiFab = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiFab'];
  defaultProps?: ComponentsProps['MuiFab'];
  variants?: ComponentsVariants['MuiFab'];
};

export const MuiFab: MuiFab = {
  defaultProps: {
    variant: 'extended',
    disableFocusRipple: true,
    disableRipple: true,
    disableTouchRipple: true,
  },
  variants: [
    {
      props: { color: 'blue' },
      style: {
        color: tannerBlue['500'],
        '&.Mui-disabled': {
          boxShadow: 'none',
          color: `${tannerBlue['500']}99`,
          'span .MuiBox-root': {
            color: tannerBlue['500'],
          },
        },
      },
    },
    {
      props: { color: 'secondary' },
      style: {
        color: tannerBlack,
        '&.Mui-disabled': {
          boxShadow: 'none',
          color: `${tannerBlack}99`,
          'span .MuiBox-root': {
            color: tannerBlack,
          },
        },
      },
    },
    {
      props: { color: 'error' },
      style: {
        color: tannerSemantic.error.color,
        '&.Mui-disabled': {
          boxShadow: 'none',
          color: `${tannerSemantic.error.color}99`,
          'span .MuiBox-root': {
            color: tannerSemantic.error.color,
          },
        },
      },
    },
    {
      props: { variant: 'circular' },
      style: {
        borderRadius: '50%',
        height: 40,
        width: 40,
        padding: 0,
      },
    },
  ],
  styleOverrides: {
    root: {
      borderRadius: 100,
      background: tannerGray['50'],
      boxShadow:
        '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.17), 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
      height: '40px',
      lineHeight: '140%',
      color: tannerPurple['500'],
      fontSize: 14,
      padding: '8px 16px 8px 16px',
      fontWeight: 700,
      textTransform: 'none',
      '&:hover': {
        background: tannerGray['200'],
        boxShadow:
          '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 4px 5px 0px rgba(0, 0, 0, 0.12), 0px 1px 10px 0px rgba(0, 0, 0, 0.20)',
      },
      '&:active': {
        background: tannerGray['300'],
        boxShadow:
          '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.17), 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
      },
      '&.Mui-disabled': {
        boxShadow: 'none',
        background: tannerGray['100'],
        color: `${tannerPurple['500']}99`,
        'span .MuiBox-root': {
          color: tannerPurple['500'],
        },
      },
      '&:focus-visible': {
        borderRadius: '37px',
        outline: `3px solid ${tannerSemantic.info.color}`,
        outlineOffset: 3,
        transition: 'outline-offset 150ms',
      },
    },
  },
};
